import { useFormaliteService } from '@europrocurement/l2d-domain';
import { ReglementsEtAcomptesCBJsonldReglementRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type CollectionReglementType = ReglementsEtAcomptesCBJsonldReglementRead;

const useCollectionReglement = () => {
    const { reglementsApi } = useFormaliteService();
    let searchFormalisteTimeout: number | undefined;
    const searchCollectionReglement = (
        collectionIds: number[],
    ): Promise<Array<CollectionReglementType>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchFormalisteTimeout);
            searchFormalisteTimeout = setTimeout(() => {
                reglementsApi
                    .apiReglementsGetCollection({ detailsReglementsIdCollectionId2: collectionIds })
                    .then((res) =>
                        resolve(res.data['hydra:member'] as Array<CollectionReglementType>),
                    )
                    .catch(() => reject());
            }, 300);
        });

    return { searchCollectionReglement };
};

export default useCollectionReglement;
